import { motion } from 'framer-motion';
import { fadeUp } from '../../utils/animations';

export function OptionalMonitoring() {
    return (
        <section className="bg-white py-24 md:py-32" data-testid="optional-monitoring">
            <div className="max-w-3xl mx-auto px-6 lg:px-12">
                <motion.div {...fadeUp}>
                    <h2 className="font-montserrat font-bold text-3xl md:text-4xl text-navy-900 tracking-tight mb-6">
                        Already Have a VA? We Can Monitor Them Too.
                    </h2>
                    <div className="space-y-6 text-[#6B7280] text-lg leading-relaxed">
                        <p>
                            If you have VAs you hired on your own, you can add timeclock monitoring for $100/month per VA. Same audit process, same monthly summary, same accountability layer. No need to switch anything about how they work. Just plug them into the system and let us keep an eye on things.
                        </p>
                        <p>
                            This is completely optional and can be added or removed at any time.
                        </p>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
